<template>
  <LocationCell
    :country="contact.country?.name ?? ''"
    :country-code="contact.country?.isoCode ?? null"
    :detail="cityDetails"
    :title="contact.country?.name ?? ''"
    no-icon-fallback
    :country-data-test="`tc-country-${index}`"
    :detail-data-test="`tc-country-details-${index}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import LocationCell from '@/components/LocationCell.vue'

const TrustedContactLocationColumn = graphql(`
  fragment TrustedContactLocationColumn on TrustedContact {
    id
    worker {
      id
      address {
        city
        state
        country {
          isoCode
          name
        }
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof TrustedContactLocationColumn>; index: number }>()
const column = computed(() => useFragment(TrustedContactLocationColumn, props.row))

const contact = computed(() => ({
  country: column.value.worker.address?.country,
  city: column.value.worker.address?.city,
  state: column.value.worker.address?.state,
}))

const cityDetails = computed(() => {
  const { city, state } = contact.value

  if (!city && !state) {
    return '-'
  }

  const sanitizedCity = city
    ? city
        .toLowerCase()
        .split(' ')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : null

  if (state && sanitizedCity) {
    return `${sanitizedCity}, ${state}`
  }

  return sanitizedCity ?? `-, ${state}`
})
</script>
